// react and js
import PropTypes from "prop-types";
import { React, useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";


// mui
import {
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Link,
  Stack,
  Box,
} from "@mui/material";

// components
import ModalDialog from "../../../components/ModalDialog";
import Iconify from "../../../components/Iconify";

// hooks

// layouts

// pages

// theme
import { B1Small } from "../../../theme/styled";

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function IncludedSymbols({ plan, details }) {
  // ----------------------------------------------------------------------
  // Properties
  // ----------------------------------------------------------------------
  IncludedSymbols.propTypes = {
    plan: PropTypes.any.isRequired,
    details: PropTypes.any.isRequired,
  };

  const { t } = useTranslation();

  // console.log(details);

  // eslint-disable-next-line
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const descriptionElementRef = useRef(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const [scroll, setScroll] = useState("paper");

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };
  const handleClickClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Typography variant="contentSmallBold">
        {/* eslint-disable-next-line */}
        <Link
          component="button"
          onClick={handleClickOpen("paper")}
          underline="none"
          variant="contentSmallLink"
          color="black"
          sx={{ cursor: "pointer" }}
        >
          {t("distributionTickData.includedSymbols.link")}
        </Link>
      </Typography>

      <ModalDialog
        open={open}
        handleClose={handleClose}
        scroll={scroll}
        outlet={
          <>
            <DialogTitle
              id="dialog-title"
              sx={{
                background: "#F2F2F2",
                textTransform: "none",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                alignContent: "center",
                py: 1,
                pr: 1,
              }}
            >
              <Typography variant="contentBig">
                {t("distributionTickData.includedSymbols.title", {
                  plan: plan.plan_description.toLowerCase(),
                })}
              </Typography>

              <IconButton
                onClick={handleClickClose}
                sx={{ borderRadius: "10px" }}
              >
                <Iconify
                  icon="eva:close-outline"
                  minWidth={25}
                  minHeight={25}
                  color="#2E2E2E"
                />
              </IconButton>
            </DialogTitle>

            <DialogContent
              dividers
              sx={{
                background: "#F2F2F2",
                borderTop: "1px solid #C8C8C8",
                borderBottom: "0px solid #C8C8C8",
              }}
            >
              <Box sx={{ mb: 2 }}>
                <Typography variant="contentMiddle">
                  {t("distributionTickData.includedSymbols.intro")}
                </Typography>

                <Typography variant="contentMiddle">
                  <br />
                  <br />
                  {t("distributionTickData.includedSymbols.availableInPart1")}{' '}
                  <Typography
                    variant="contentMiddle"
                    sx={{ textDecoration: "underline" }}
                  >
                    {t("distributionTickData.includedSymbols.spreadEmphasis")}
                  </Typography>{' '}
                  {t("distributionTickData.includedSymbols.availableInPart2")}
                  <Typography variant="contentMiddleBold">
                    <Link
                      variant="contentMiddleLink"
                      underline="none"
                      target="_blank"
                      color="inherit"
                      href={plan.user_manual_url}
                    >
                      {` ${t("distributionTickData.includedSymbols.userManualLink")}`}
                    </Link>
                  </Typography>
                  .
                </Typography>
              </Box>

              {details.map((row, index) => (
                <Stack
                  key={index}
                  spacing="3px"
                  sx={{ background: "white", mb: 1, px: "10px", py: "5px", borderRadius: "10px"}}
                >
                  <Box sx={{ display: "flex" }}>
                    <Box sx={{ width: "40%", pr: 1 }}>
                      <Typography variant="contentSmallBold">
                        {t("distributionTickData.includedSymbols.symbolLabel")}
                      </Typography>
                    </Box>
                    <Box sx={{ width: "60%", pl: 1 }}>
                      <Typography variant="contentSmall">
                        {row.symbol_name}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex" }}>
                    <Box sx={{ width: "40%", pr: 1 }}>
                      <Typography variant="contentSmallBold">
                        {` ${t("distributionTickData.includedSymbols.typeLabel")} `}
                      </Typography>
                    </Box>
                    <Box sx={{ width: "60%", pl: 1 }}>
                      <Typography variant="contentSmall">
                        {row.symbol_group}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex" }}>
                    <Box sx={{ width: "40%", pr: 1 }}>
                      <Typography variant="contentSmallBold">
                        {t("distributionTickData.includedSymbols.startDateLabel")}
                      </Typography>
                    </Box>
                    <Box sx={{ width: "60%", pl: 1 }}>
                      <Typography variant="contentSmall">
                        {row.start_date}
                      </Typography>
                    </Box>
                  </Box>
                </Stack>
              ))}
            </DialogContent>

            <DialogActions
              sx={{
                background: "#F2F2F2",
                p: 0,
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <B1Small
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                onClick={handleClose}
              >
                {t("distributionTickData.includedSymbols.closeButton")}
              </B1Small>
            </DialogActions>
          </>
        }
      />
    </>
  );
}
